// Typelizer digest 872636f05538628b75f7744629847d82
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /auth/google_oauth2/start */
  google: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/auth/google_oauth2/start', {}, options),
    method: 'post',
  }),
}
